// "use client";

import React from "react";
import Image from "next/image";

import {
    BannerDescContainer,
    FloatingArrow,
    ImageDescContainer,
    SingleImageContainer,
    TextContainer,
    TextFloatImageContainer,
    WorkThumbnail,
    IntroContainer,
    ContactButton,
    SocialIcons,
    BottomCurves,
} from "@/utils/globalComponent";
import Link from "next/link";
import {
    BannerBlock,
    ImageContentBlock,
    ImageTextBannerBlock,
    ImageTextBannerCustomBlock,
    IntroBlock,
} from "../../../global";
import { getStrapiMedia, getStrapiURL } from "@/utils/api-helpers";
import PortfolioHolder from "@/components/container/portfolioHolder";

export function getSection(section: any) {
    const components: JSX.Element[] = [];

    section?.blocks.forEach((block: any, index: number) => {
        switch (block.__component) {
            case "blocks.image-content":
                components.push(
                    <React.Fragment key={index}>
                        {getImageContentBlock(block, index)}
                    </React.Fragment>
                );
                break;
            case "blocks.text-content":
                components.push(
                    <React.Fragment key={index}>
                        {getTextContent(block)}
                    </React.Fragment>
                );
                break;
            default:
                break;
        }
    });

    return components;
}

export function getImageContentBlock(
    { image }: ImageContentBlock,
    index: number
) {
    const imageSrc = getStrapiMedia(image.url);
    return (
        <SingleImageContainer
            key={index}
            className={""}
            altText={image.alternativeText}
            imageSrc={imageSrc}
        />
    );
}

export function getTextContent(block: any) {
    return (
        <section className="bg-lightGrey py-28">
            <FloatingArrow direction={"left"} className={"left-[6vw]"} />
            <TextContainer
                description={block.description}
                className={""}
                serviceName={null}
                header={null}
            />
        </section>
    );
}

export function textTurquoise(text: string) {
    let filteredText = text;
    if (text.includes("--*") && text.includes("*--")) {
        filteredText = text.replace(
            /--\*(.*?)\*--/g,
            (_, match) => `<span class=' text-turquoise'>${match}</span>`
        );
        return <span dangerouslySetInnerHTML={{ __html: filteredText }} />;
    }
    return filteredText;
}

export function textTransparent(text: string) {
    let filteredText = text;
    if (text.includes("--*") && text.includes("*--")) {
        filteredText = text.replace(
            /--\*(.*?)\*--/g,
            (_, match) =>
                `<span class=' text-transparent text-stroke-purple'>${match}</span>`
        );
        return (
            <span
                className="text-inherit"
                dangerouslySetInnerHTML={{ __html: filteredText }}
            ></span>
        );
    }
    return filteredText;
}
